// https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag
import logEvent from 'utils/log'

// use recommended events
// https://support.google.com/analytics/answer/9267735?hl=en

export function logGetStartedEvent(name) {
  logEvent(`getstarted: ${name} (v1)`)
}
